<template>
  <section class="app-main" ref="main">
    <transition name="fade-transform" mode="out-in">
      <keep-alive include="cart">
        <router-view />
      </keep-alive>

      <!-- <router-view :key="key" /> -->
    </transition>
    <!-- <keep-alive :include="cachedViews">
      <router-view :key="key" />
    </keep-alive> -->
    <!-- <router-view /> -->
  </section>
</template>

<script>
export default {
  name: "AppMain",
  computed: {
    // cachedViews() {
    //   return this.$store.state.tagsView.cachedViews;
    // },
    key() {
      return this.$route.path;
    },
  },

  // mounted(){
  //   debugger
  //   let test=this.$router
  //   debugger
  //   this.$router.afterEach((to,from)=>{
  //     debugger
  //     if(to.name==from.name=='dashboard'){
  //       this.$nextTick(()=>{
  //         location.reload()
  //       })
  //     }
  //   })
  // }
};
</script>

<style lang="scss" scoped>
.app-main {
  /* 50= navbar  50  */
  // min-height: calc(100vh - 50px);
  // width: 100%;

  flex: 1;
  position: relative;
  background-color: inherit;
  // overflow: hidden;
  // overflow: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  // background: #fff;
  // background-color: #fff;
  // margin-right:40px;

  // display: grid;
  // grid-template-rows: repeat(1,1fr);

  // display: grid;
  // grid-template-rows:100%;
  //  grid-template-rows:repeat(1, 100%);
}

.fixed-header + .app-main {
  padding-top: 50px;
}

.hasTagsView {
  .app-main {
    /* 84 = navbar + tags-view = 50 + 34 */
    min-height: calc(100vh - 84px);
  }

  .fixed-header + .app-main {
    padding-top: 84px;
  }
}
</style>

<style lang="scss">
// fix css style bug in open el-dialog
.el-popup-parent--hidden {
  .fixed-header {
    padding-right: 15px;
  }
}
</style>
